namespace ExtendedProperties {
    export interface Property extends Partial<more.EntityAPIResult>  {
        property_type: Type,
        $property_type: Type,
        ref_parent_property?: Property,
        EL_vt_extended_property_children?: Array<Property>,
        childcount_max?: number,
        childcount_min?: number,
        entity_label_attribute?: string,
        entity_label_attribute_secondary?: string,
        entity_coloration_attribute?: string,
        value_max?: number,
        value_min?: number,
        value_precision?: number
        description: string,
        description_long?: string,
        code: string,
        filter_file?: string,
        gDisp_1: string,
        is_active: boolean,
        is_mandatory: boolean,
        order: number,
        EL_ht_property_assignments: Array<PropertyAssignment<any>>
        EL_extended_property_values: Array<ValueTemplate>
    }

    export interface ValueTemplate extends more.EntityAPIResult {
        description: string,
        value_text: string,
        value_double: number,
        coloration: more.EntityAPIColor
    }
    export interface AssignmentValue<T> extends Partial<more.EntityAPIResult> {
        ref_vt_extended_property_assignment: PropertyAssignment<T>
        ref_extended_property_value_source?: ValueTemplate
        value_display: string,
        value_date?: Date,
        value_text: string,
        value_double?: number
    }
    export interface AssignmentValue_File<T> extends AssignmentValue<T> {
        tmp_json_value_file?: string
        value_filelink?: string
    }
    export interface AssignmentValue_Entity<T, X> extends AssignmentValue<T> {
        value_entity?: X
    }

    export interface FileValueDescriptor extends FileFinder.FileDescriptor {
        ID: string;
    }


    export interface PropertyAssignment<T> extends Partial<more.EntityAPIResult> {
        ref_vt_extended_property: Property,
        value_json?: string,
        ref_extended_property_value_source?: ValueTemplate
        EL_values?: Array<AssignmentValue<T>>
        order_2?: number,
        ref_entity?: T,
        entity_classname?: string,
        value_display: string,
        value_date?: Date,
        value_bool?: boolean,
        value_text?: string,
        value_double?: number,
        //content_base64?: string,
        ref_parent_ht_extended_property_assignment?: PropertyAssignment<T>
        gDisp_1?: string,
        is_active?: boolean,
        is_mandatory?: boolean,
        order: number,
        
    }

    export interface PropertyAssignment_EntityValue<T, X> extends PropertyAssignment<T> {
        value_entity?: X

    }
    export interface PropertyAssignment_FileValue<T> extends PropertyAssignment<T> {
        //tmp_json_value_file?: string
        //value_filelink?: string
        EL_values?: Array<AssignmentValue_File<T>>
    }

    export enum Type {
        string = "string",
        string_long = "string_long",
        number = "number",
        listvalue = "listvalue",
        listvalue_multi = "listvalue_multi",
        filterlistvalue = "filterlistvalue",
        filterlistvalue_multi = "filterlistvalue_multi",
        file = "file",
        file_multi = "file_multi",
        date = "date",
        bool = "bool",
        datetime = "datetime",
        propertylist = "propertylist",
        propertygroup = "propertygroup"
    }
}

export {
    ExtendedProperties
}